module.exports = __webpack_public_path__ + "static/img/pic001.d1f178c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pic001.png
// module id = jpPM
// module chunks = 1